import { render } from "./BaseListAssets.vue?vue&type=template&id=a3e2da98"
import script from "./BaseListAssets.vue?vue&type=script&lang=js"
export * from "./BaseListAssets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__